import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuideMockSelect from '../components/GuideMockSelect';
import GuideMockTextField from '../components/GuideMockTextField';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideContractTemplate: React.FC = () => {
  return (
    <GuidePageLayout
      title="テンプレート（自由項目）を管理する"
      description="契約申請フォームに表示される動的項目（テンプレート）を追加・編集・並び替えします。"
      breadcrumbs={[{ label: '契約管理', path: '/guide/contract/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable headers={['条件', '内容']} rows={[['必要な権限', '管理者 / 管理部門']]} />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: '契約管理メニューから申請フォーム設定画面を開く' },
            {
              label: 'グループを追加する場合は「グループ追加」ボタンを押下',
              content: (
                <GuideMockContainer label="グループ追加">
                  <Stack spacing={1}>
                    <GuideMockButton
                      label="グループ追加"
                      variant="outlined"
                      startIcon={<AddIcon />}
                      size="small"
                    />
                    <GuideMockTextField label="グループ名" required />
                  </Stack>
                </GuideMockContainer>
              ),
            },
            {
              label: '項目を追加する場合はアイテム追加アイコンをクリック',
              content: (
                <GuideMockContainer label="項目追加フォーム">
                  <Stack spacing={1.5}>
                    <GuideMockTextField
                      label="項目キー"
                      required
                      helperText="半角英数字+ハイフン+アンダースコア"
                    />
                    <GuideMockTextField label="ラベル" required />
                    <GuideMockSelect
                      label="フォーム種別"
                      options={[
                        'テキスト',
                        'テキストエリア',
                        'セレクト',
                        'マルチセレクト',
                        'チェックボックス',
                      ]}
                      required
                    />
                  </Stack>
                </GuideMockContainer>
              ),
            },
            { label: 'グループや項目の表示順はドラッグ&ドロップで変更する' },
            { label: '非表示にする場合はグループの表示Switchを切り替える' },
          ]}
        />
      </GuideSection>

      <GuideSection title="入力項目（グループ追加時）">
        <GuideTable
          headers={['項目名', '必須', '形式', '備考']}
          rows={[['グループ名', '必須', 'テキスト（最大300桁）', '']]}
        />
      </GuideSection>

      <GuideSection title="入力項目（アイテム追加時）">
        <GuideTable
          headers={['項目名', '必須', '形式', '備考']}
          rows={[
            [
              '項目キー',
              '必須',
              'テキスト（最大100桁）',
              '半角英数字+ハイフン+アンダースコア。重複不可',
            ],
            ['ラベル', '必須', 'テキスト（最大300桁）', '画面表示名'],
            ['フォーム種別', '必須', 'プルダウン', 'マスタ区分から選択'],
            ['選択肢', '条件付き', 'リスト', '選択系フォーム種別の場合に追加'],
          ]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox type="warning">固定項目グループは編集・削除できません。</GuideInfoBox>
          <GuideInfoBox type="warning">
            項目キーは登録後に変更できません。慎重に設定してください。
          </GuideInfoBox>
          <GuideInfoBox>項目の削除はグループ未所属時のみ可能です（論理削除）。</GuideInfoBox>
          <GuideInfoBox>
            既存の契約申請に紐付いた項目値は削除されません（過去データ保全）。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideContractTemplate;
